import { IonCardSubtitle } from '@ionic/react';
import styled from 'styled-components';

export const IonSubTitleLogin = styled(IonCardSubtitle)`
  margin-bottom: 2%;
  color: var(--ion-text-color);
  font-weight: 200;
  font-size: 0.8rem;
  font-family: 'Inter-ExtraBold', sans-serif;
`;
